import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './newTrip.actions.js';
import getters from './newTrip.getters.js';
import mutations from './newTrip.mutations.js';
import state from './newTrip.state.js';

BaseStore.registerModule('newTrip', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('newTrip');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
